import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Navbar } from './components'
import { Jokes, Favorite } from './pages'
import { Switch, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './store'

function App() {
  return (
    <>
    <Provider store={store}>
    <Navbar/>
    <Switch>
      <Route exact path="/">
        <Jokes/>
      </Route>
      <Route exact path="/fav">
        <Favorite/>
      </Route>
    </Switch>
    </Provider>
    </>
  );
}

export default App;
